const BaseInput = ({ component: Component, ...props }) => (
  <Component
    minRows="3"
    {...props}
    multiline
  />
);

export default BaseInput;
